import { __makeTemplateObject, __assign } from 'tslib';
import React__default, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Box } from '../box/Box.js';
import { Button } from '../button/Button.js';
import { Heading } from '../heading/Heading.js';
import SearchIcon from '../../../node_modules/@vinomofo/icons/esm/SearchIcon-fce6bae0.js';

var Input = function (props) {
  return React__default.createElement(Heading, __assign({
    as: "input"
  }, props));
};
var InputContainer = /*#__PURE__*/styled(Box).withConfig({
  displayName: "SearchInput__InputContainer",
  componentId: "sc-rox9fu-0"
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: relative;\n  width: 100%;\n  font-size: inherit;\n  white-space: nowrap;\n\n  .page-title,\n  input {\n    position: absolute;\n    top: 0;\n    outline: 0;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    line-height: unset;\n    background: none;\n    font-size: inherit;\n    overflow: hidden;\n    width: 100%;\n  }\n"], ["\n  position: relative;\n  width: 100%;\n  font-size: inherit;\n  white-space: nowrap;\n\n  .page-title,\n  input {\n    position: absolute;\n    top: 0;\n    outline: 0;\n    margin: 0;\n    padding: 0;\n    border: 0;\n    line-height: unset;\n    background: none;\n    font-size: inherit;\n    overflow: hidden;\n    width: 100%;\n  }\n"])));
var SearchInput = function (_a) {
  var query = _a.query,
    placeholder = _a.placeholder,
    title = _a.title,
    onSubmit = _a.onSubmit,
    onChange = _a.onChange,
    onFocus = _a.onFocus,
    onBlur = _a.onBlur;
  var _b = useState(query),
    searchTerm = _b[0],
    setSearchTerm = _b[1];
  useEffect(function () {
    setSearchTerm(query);
  }, [query]);
  var _c = useState(false),
    focused = _c[0],
    setFocused = _c[1];
  var handleFocus = function () {
    setFocused(true);
    onFocus === null || onFocus === void 0 ? void 0 : onFocus();
  };
  var handleBlur = function () {
    setFocused(false);
    onBlur === null || onBlur === void 0 ? void 0 : onBlur();
  };
  var handleSearch = function (e) {
    e.preventDefault();
    onSubmit(searchTerm || "");
  };
  var handleChange = function (e) {
    e.preventDefault();
    var value = e.target.value || "";
    setSearchTerm(value);
    onChange(value);
  };
  var showHeading = !(focused || searchTerm);
  var showPlaceholder = !searchTerm && (focused || !title);
  return React__default.createElement(Box, {
    display: "flex",
    width: "100%",
    fontSize: [8, 12, 14],
    borderBottom: "2px solid",
    borderColor: "brand"
  }, React__default.createElement(Button, {
    color: "brand",
    marginRight: 10,
    onClick: function () {
      return onSubmit(searchTerm || "");
    },
    fontSize: "inherit"
  }, React__default.createElement(SearchIcon, {
    size: "0.75em"
  })), React__default.createElement(InputContainer, null, React__default.createElement(Box, {
    display: showHeading ? "inline" : "none"
  }, React__default.createElement(Heading, {
    className: "page-title",
    as: "h1",
    color: "text.heading",
    fontSize: "inherit"
  }, title)), React__default.createElement("form", {
    onSubmit: handleSearch
  }, React__default.createElement(Input, {
    type: "text",
    fontWeight: 700,
    placeholder: showPlaceholder ? placeholder : "",
    value: searchTerm || "",
    onChange: handleChange,
    onFocus: handleFocus,
    onBlur: handleBlur
  }))));
};
var templateObject_1;

export { SearchInput };
//# sourceMappingURL=SearchInput.js.map
